// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BUYERS_NO_RESULTS = "Moment\u00e1ln\u011b nem\u00e1\u0161 \u017e\u00e1dn\u00e9 z\u00e1jemce.";
export const BZ2_MESSAGES_FOR_PRODUCT = "Zpr\u00e1vy k tomuto inzer\u00e1tu";
export const BZ2_REMOVED_BUYERS = "Odstran\u011bn\u00ed z\u00e1jemci";
